
import React, { useState } from 'react';
import { 
  Building, 
  Users, 
  MapPin, 
  Phone, 
  Mail, 
  Plus, 
  Search, 
  Filter,
  Eye,
  Edit,
  Trash2,
  UserPlus,
  Settings,
  Calendar,
  Clock,
  Package,
  Truck,
  FileSpreadsheet,
  Building2,
  MapPinned,
  UserCheck,
  UserX,
  Shield,
  Award,
  Activity,
  Copy,
  ArrowUpDown
} from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useToast } from '@/hooks/use-toast';

const Hubs = () => {
  const { toast } = useToast();

  // Mock data for hubs
  const [hubs] = useState([
    {
      id: 'HUB001',
      name: 'Trung tâm khai thác Hà Nội',
      code: 'HN001',
      type: 'Trung tâm khai thác',
      address: 'Số 123, Đường Láng, Đống Đa, Hà Nội',
      phone: '024-1234-5678',
      email: 'hanoi@busexpress.vn',
      manager: 'Nguyễn Văn A',
      status: 'active',
      capacity: 1000,
      currentLoad: 750,
      employeeCount: 25,
      createdAt: '2024-01-15T08:00:00+07:00',
      operatingHours: '06:00 - 22:00',
      services: ['Gửi hàng', 'Nhận hàng', 'Trung chuyển', 'Kho bãi']
    },
    {
      id: 'HUB002',
      name: 'Chi nhánh Cầu Giấy',
      code: 'CG001',
      type: 'Chi nhánh',
      address: 'Số 456, Đường Cầu Giấy, Cầu Giấy, Hà Nội',
      phone: '024-2345-6789',
      email: 'caugiay@busexpress.vn',
      manager: 'Trần Thị B',
      status: 'active',
      capacity: 500,
      currentLoad: 320,
      employeeCount: 12,
      createdAt: '2024-02-01T08:00:00+07:00',
      operatingHours: '07:00 - 21:00',
      services: ['Gửi hàng', 'Nhận hàng']
    },
    {
      id: 'HUB003',
      name: 'Bến xe Giáp Bát',
      code: 'GB001',
      type: 'Bến xe',
      address: 'Bến xe Giáp Bát, Hoàng Mai, Hà Nội',
      phone: '024-3456-7890',
      email: 'giapbat@busexpress.vn',
      manager: 'Lê Văn C',
      status: 'maintenance',
      capacity: 800,
      currentLoad: 0,
      employeeCount: 18,
      createdAt: '2024-01-20T08:00:00+07:00',
      operatingHours: '05:00 - 23:00',
      services: ['Trung chuyển', 'Vận chuyển']
    },
    {
      id: 'HUB004',
      name: 'Kho Đông Anh',
      code: 'DA001',
      type: 'Kho hàng',
      address: 'Khu công nghiệp Đông Anh, Hà Nội',
      phone: '024-4567-8901',
      email: 'donganh@busexpress.vn',
      manager: 'Phạm Văn D',
      status: 'active',
      capacity: 2000,
      currentLoad: 1200,
      employeeCount: 35,
      createdAt: '2024-01-10T08:00:00+07:00',
      operatingHours: '24/7',
      services: ['Kho bãi', 'Trung chuyển', 'Phân loại']
    }
  ]);

  // Mock data for employees
  const [employees] = useState([
    {
      id: 'NV001',
      name: 'Nguyễn Văn E',
      email: 'nvane@busexpress.vn',
      phone: '0901234567',
      hubId: 'HUB001',
      hubName: 'Trung tâm khai thác Hà Nội',
      position: 'Quản lý hub',
      department: 'Vận hành',
      status: 'active',
      joinDate: '2024-01-15T08:00:00+07:00'
    },
    {
      id: 'NV002',
      name: 'Trần Thị F',
      email: 'ttf@busexpress.vn',
      phone: '0909876543',
      hubId: 'HUB001',
      hubName: 'Trung tâm khai thác Hà Nội',
      position: 'Nhân viên kho',
      department: 'Kho vận',
      status: 'active',
      joinDate: '2024-02-01T08:00:00+07:00'
    },
    {
      id: 'NV003',
      name: 'Lê Văn G',
      email: 'lvg@busexpress.vn',
      phone: '0987654321',
      hubId: 'HUB002',
      hubName: 'Chi nhánh Cầu Giấy',
      position: 'Tài xế',
      department: 'Vận chuyển',
      status: 'active',
      joinDate: '2024-01-20T08:00:00+07:00'
    }
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [typeFilter, setTypeFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [hoveredField, setHoveredField] = useState(null);

  // Hub CRUD states
  const [showCreateHubDialog, setShowCreateHubDialog] = useState(false);
  const [showEditHubDialog, setShowEditHubDialog] = useState(false);
  const [showHubDetailsDialog, setShowHubDetailsDialog] = useState(false);
  const [selectedHub, setSelectedHub] = useState(null);

  // Employee CRUD states
  const [showCreateEmployeeDialog, setShowCreateEmployeeDialog] = useState(false);
  const [showAssignEmployeeDialog, setShowAssignEmployeeDialog] = useState(false);
  const [showEditEmployeeDialog, setShowEditEmployeeDialog] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  // Mock data cho available users (tài khoản có sẵn)
  const [availableUsers] = useState([
    {
      id: 'USR001',
      name: 'Nguyễn Văn H',
      email: 'nvh@busexpress.vn',
      phone: '0911223344',
      position: 'Nhân viên',
      department: 'Vận hành',
      assignedHubs: []
    },
    {
      id: 'USR002', 
      name: 'Trần Thị I',
      email: 'tti@busexpress.vn',
      phone: '0922334455',
      position: 'Tài xế',
      department: 'Vận chuyển',
      assignedHubs: ['HUB001']
    },
    {
      id: 'USR003',
      name: 'Lê Văn J',
      email: 'lvj@busexpress.vn', 
      phone: '0933445566',
      position: 'Giám sát',
      department: 'Kho vận',
      assignedHubs: ['HUB001', 'HUB002']
    }
  ]);

  // Copy function
  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      toast({
        title: "Đã sao chép",
        description: "Đã sao chép vào clipboard",
      });
    } catch (err) {
      console.error('Failed to copy: ', err);
      toast({
        title: "Lỗi",
        description: "Không thể sao chép",
        variant: "destructive"
      });
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200';
      case 'maintenance':
        return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200';
      case 'inactive':
        return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200';
      default:
        return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200';
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'Trung tâm khai thác':
        return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200';
      case 'Chi nhánh':
        return 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200';
      case 'Bến xe':
        return 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200';
      case 'Kho hàng':
        return 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-200';
      default:
        return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'active':
        return 'Hoạt động';
      case 'maintenance':
        return 'Bảo trì';
      case 'inactive':
        return 'Ngừng hoạt động';
      default:
        return 'Không xác định';
    }
  };

  const getLoadPercentage = (current, capacity) => {
    return Math.round((current / capacity) * 100);
  };

  const getLoadColor = (percentage) => {
    if (percentage >= 90) return 'text-red-600';
    if (percentage >= 70) return 'text-yellow-600';
    return 'text-green-600';
  };

  const handleCreateHub = () => {
    setShowCreateHubDialog(true);
  };

  const handleViewDetails = (hub) => {
    setSelectedHub(hub);
    setShowHubDetailsDialog(true);
  };

  const handleEditHub = (hub) => {
    setSelectedHub(hub);
    setShowEditHubDialog(true);
  };

  const handleDeleteHub = (hub) => {
    if (confirm(`Bạn có chắc chắn muốn xóa hub "${hub.name}"?`)) {
      toast({
        title: "Thành công",
        description: `Đã xóa hub ${hub.name}`,
      });
    }
  };

  const handleCreateEmployee = () => {
    setShowCreateEmployeeDialog(true);
  };

  const handleAssignEmployee = () => {
    setShowAssignEmployeeDialog(true);
  };

  const handleEditEmployee = (employee) => {
    setSelectedEmployee(employee);
    setShowEditEmployeeDialog(true);
  };

  const handleDeleteEmployee = (employee) => {
    if (confirm(`Bạn có chắc chắn muốn xóa nhân viên "${employee.name}"?`)) {
      toast({
        title: "Thành công", 
        description: `Đã xóa nhân viên ${employee.name}`,
      });
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-foreground">Quản lý bưu cục</h1>
          <p className="text-muted-foreground">Quản lý các hub, chi nhánh và nhân sự</p>
        </div>
        <Dialog open={showCreateHubDialog} onOpenChange={setShowCreateHubDialog}>
          <DialogTrigger asChild>
            <Button onClick={handleCreateHub}>
              <Plus className="h-4 w-4 mr-2" />
              Tạo hub mới
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-2xl">
            <DialogHeader>
              <DialogTitle>Tạo hub mới</DialogTitle>
            </DialogHeader>
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="hubName">Tên hub</Label>
                  <Input placeholder="Nhập tên hub" />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="hubCode">Mã hub</Label>
                  <Input placeholder="Nhập mã hub" />
                </div>
              </div>
              <div className="space-y-2">
                <Label htmlFor="hubType">Loại hub</Label>
                <Select>
                  <SelectTrigger>
                    <SelectValue placeholder="Chọn loại hub" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="center">Trung tâm khai thác</SelectItem>
                    <SelectItem value="branch">Chi nhánh</SelectItem>
                    <SelectItem value="station">Bến xe</SelectItem>
                    <SelectItem value="warehouse">Kho hàng</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div className="space-y-2">
                <Label htmlFor="address">Địa chỉ</Label>
                <Input placeholder="Nhập địa chỉ đầy đủ" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="phone">Số điện thoại</Label>
                  <Input placeholder="Nhập số điện thoại" />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="email">Email</Label>
                  <Input type="email" placeholder="Nhập email" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="manager">Quản lý</Label>
                  <Input placeholder="Tên quản lý" />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="capacity">Sức chứa</Label>
                  <Input type="number" placeholder="Sức chứa tối đa" />
                </div>
              </div>
              <div className="space-y-2">
                <Label htmlFor="operatingHours">Giờ hoạt động</Label>
                <Input placeholder="VD: 06:00 - 22:00 hoặc 24/7" />
              </div>
              <Button className="w-full">Tạo hub</Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Card>
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-muted-foreground">Tổng hub</p>
                <p className="text-2xl font-bold">{hubs.length}</p>
              </div>
              <Building className="h-8 w-8 text-muted-foreground" />
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-muted-foreground">Đang hoạt động</p>
                <p className="text-2xl font-bold text-green-600">
                  {hubs.filter(h => h.status === 'active').length}
                </p>
              </div>
              <Activity className="h-8 w-8 text-green-600" />
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-muted-foreground">Tổng nhân viên</p>
                <p className="text-2xl font-bold">
                  {hubs.reduce((sum, h) => sum + h.employeeCount, 0)}
                </p>
              </div>
              <Users className="h-8 w-8 text-muted-foreground" />
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-muted-foreground">Tổng sức chứa</p>
                <p className="text-2xl font-bold">
                  {hubs.reduce((sum, h) => sum + h.capacity, 0).toLocaleString()}
                </p>
              </div>
              <Package className="h-8 w-8 text-muted-foreground" />
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Main Content */}
      <Tabs defaultValue="hubs" className="space-y-4">
        <TabsList>
          <TabsTrigger value="hubs">Danh sách Hub</TabsTrigger>
          <TabsTrigger value="employees">Nhân viên</TabsTrigger>
          <TabsTrigger value="analytics">Thống kê</TabsTrigger>
        </TabsList>

        <TabsContent value="hubs" className="space-y-4">
          {/* Filters */}
          <Card>
            <CardContent className="p-4">
              <div className="flex flex-col sm:flex-row gap-4">
                <div className="relative flex-1">
                  <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
                  <Input
                    placeholder="Tìm kiếm hub theo tên, mã, địa chỉ..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="pl-10"
                  />
                </div>
                
                <Select value={typeFilter} onValueChange={setTypeFilter}>
                  <SelectTrigger className="w-full sm:w-48">
                    <SelectValue placeholder="Lọc theo loại" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">Tất cả loại</SelectItem>
                    <SelectItem value="Trung tâm khai thác">Trung tâm khai thác</SelectItem>
                    <SelectItem value="Chi nhánh">Chi nhánh</SelectItem>
                    <SelectItem value="Bến xe">Bến xe</SelectItem>
                    <SelectItem value="Kho hàng">Kho hàng</SelectItem>
                  </SelectContent>
                </Select>

                <Select value={statusFilter} onValueChange={setStatusFilter}>
                  <SelectTrigger className="w-full sm:w-48">
                    <SelectValue placeholder="Lọc theo trạng thái" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">Tất cả trạng thái</SelectItem>
                    <SelectItem value="active">Hoạt động</SelectItem>
                    <SelectItem value="maintenance">Bảo trì</SelectItem>
                    <SelectItem value="inactive">Ngừng hoạt động</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </CardContent>
          </Card>

          {/* Hubs Table */}
          <Card>
            <CardHeader>
              <CardTitle>Danh sách bưu cục</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="w-full overflow-x-auto">
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead className="min-w-[16em]">
                        <div className="flex items-center gap-2">
                          Hub
                          <ArrowUpDown className="h-4 w-4 cursor-pointer" />
                        </div>
                      </TableHead>
                      <TableHead className="min-w-[16em]">
                        <div className="flex items-center gap-2">
                          Loại
                          <ArrowUpDown className="h-4 w-4 cursor-pointer" />
                        </div>
                      </TableHead>
                      <TableHead className="min-w-[16em]">Liên hệ</TableHead>
                      <TableHead className="min-w-[16em]">Quản lý</TableHead>
                      <TableHead className="min-w-[16em]">Công suất</TableHead>
                      <TableHead className="min-w-[16em]">Nhân sự</TableHead>
                      <TableHead className="min-w-[16em]">
                        <div className="flex items-center gap-2">
                          Trạng thái
                          <ArrowUpDown className="h-4 w-4 cursor-pointer" />
                        </div>
                      </TableHead>
                      <TableHead className="w-[200px] text-center sticky right-0 bg-background z-10 border-l">Thao tác</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {hubs.map((hub) => {
                      const loadPercentage = getLoadPercentage(hub.currentLoad, hub.capacity);
                      return (
                        <TableRow key={hub.id}>
                          <TableCell>
                            <div>
                              <div 
                                className="font-medium cursor-pointer flex items-center gap-2"
                                onMouseEnter={() => setHoveredField(`name-${hub.id}`)}
                                onMouseLeave={() => setHoveredField(null)}
                                onClick={() => copyToClipboard(hub.name)}
                              >
                                {hub.name}
                                {hoveredField === `name-${hub.id}` && (
                                  <Copy className="h-3 w-3 text-muted-foreground" />
                                )}
                              </div>
                              <div 
                                className="text-sm text-muted-foreground cursor-pointer flex items-center gap-2"
                                onMouseEnter={() => setHoveredField(`code-${hub.id}`)}
                                onMouseLeave={() => setHoveredField(null)}
                                onClick={() => copyToClipboard(hub.code)}
                              >
                                {hub.code}
                                {hoveredField === `code-${hub.id}` && (
                                  <Copy className="h-3 w-3 text-muted-foreground" />
                                )}
                              </div>
                              <div 
                                className="text-xs text-muted-foreground flex items-center gap-1 mt-1 cursor-pointer"
                                onMouseEnter={() => setHoveredField(`address-${hub.id}`)}
                                onMouseLeave={() => setHoveredField(null)}
                                onClick={() => copyToClipboard(hub.address)}
                              >
                                <MapPin className="h-3 w-3" />
                                <span>{hub.address}</span>
                                {hoveredField === `address-${hub.id}` && (
                                  <Copy className="h-3 w-3 text-muted-foreground ml-1" />
                                )}
                              </div>
                            </div>
                          </TableCell>
                          <TableCell>
                            <Badge className={getTypeColor(hub.type)}>
                              {hub.type}
                            </Badge>
                          </TableCell>
                          <TableCell>
                            <div className="space-y-1 text-sm">
                              <div 
                                className="flex items-center gap-1 cursor-pointer"
                                onMouseEnter={() => setHoveredField(`phone-${hub.id}`)}
                                onMouseLeave={() => setHoveredField(null)}
                                onClick={() => copyToClipboard(hub.phone)}
                              >
                                <Phone className="h-3 w-3" />
                                <span>{hub.phone}</span>
                                {hoveredField === `phone-${hub.id}` && (
                                  <Copy className="h-3 w-3 text-muted-foreground ml-1" />
                                )}
                              </div>
                              <div 
                                className="flex items-center gap-1 cursor-pointer"
                                onMouseEnter={() => setHoveredField(`email-${hub.id}`)}
                                onMouseLeave={() => setHoveredField(null)}
                                onClick={() => copyToClipboard(hub.email)}
                              >
                                <Mail className="h-3 w-3" />
                                <span>{hub.email}</span>
                                {hoveredField === `email-${hub.id}` && (
                                  <Copy className="h-3 w-3 text-muted-foreground ml-1" />
                                )}
                              </div>
                              <div className="flex items-center gap-1">
                                <Clock className="h-3 w-3" />
                                <span>{hub.operatingHours}</span>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="flex items-center gap-1">
                              <Users className="h-3 w-3" />
                              <span className="text-sm">{hub.manager}</span>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="space-y-1">
                              <div className="text-sm">
                                <span className={getLoadColor(loadPercentage)}>
                                  {hub.currentLoad.toLocaleString()}
                                </span>
                                <span className="text-muted-foreground">
                                  / {hub.capacity.toLocaleString()}
                                </span>
                              </div>
                              <div className="w-full bg-gray-200 rounded-full h-1.5">
                                <div 
                                  className={`h-1.5 rounded-full ${
                                    loadPercentage >= 90 ? 'bg-red-500' : 
                                    loadPercentage >= 70 ? 'bg-yellow-500' : 'bg-green-500'
                                  }`}
                                  style={{ width: `${Math.min(loadPercentage, 100)}%` }}
                                ></div>
                              </div>
                              <div className="text-xs text-muted-foreground">{loadPercentage}%</div>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="text-center">
                              <div className="font-medium">{hub.employeeCount}</div>
                              <div className="text-xs text-muted-foreground">nhân viên</div>
                            </div>
                          </TableCell>
                          <TableCell>
                            <Badge className={getStatusColor(hub.status)}>
                              {getStatusText(hub.status)}
                            </Badge>
                          </TableCell>
                          <TableCell className="sticky right-0 bg-background z-10 border-l">
                            <div className="flex items-center gap-1 justify-center">
                              <Button 
                                size="sm" 
                                variant="ghost" 
                                onClick={() => handleViewDetails(hub)}
                                title="Xem chi tiết"
                              >
                                <Eye className="h-4 w-4" />
                              </Button>
                              <Button 
                                size="sm" 
                                variant="ghost" 
                                onClick={() => handleEditHub(hub)}
                                title="Chỉnh sửa"
                              >
                                <Edit className="h-4 w-4" />
                              </Button>
                              <Button 
                                size="sm" 
                                variant="ghost"
                                onClick={() => handleDeleteHub(hub)}
                                title="Xóa"
                              >
                                <Trash2 className="h-4 w-4" />
                              </Button>
                              <Button 
                                size="sm" 
                                variant="ghost"
                                title="Cài đặt"
                              >
                                <Settings className="h-4 w-4" />
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="employees" className="space-y-4">
          {/* Employee Management Header */}
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-lg font-semibold">Quản lý nhân viên hub</h3>
              <p className="text-sm text-muted-foreground">Quản lý nhân sự tại các bưu cục</p>
            </div>
            <div className="flex gap-2">
              <Dialog open={showCreateEmployeeDialog} onOpenChange={setShowCreateEmployeeDialog}>
                <DialogTrigger asChild>
                  <Button variant="outline" onClick={handleCreateEmployee}>
                    <UserPlus className="h-4 w-4 mr-2" />
                    Tạo nhanh
                  </Button>
                </DialogTrigger>
                <DialogContent>
                  <DialogHeader>
                    <DialogTitle>Tạo tài khoản người dùng nội bộ</DialogTitle>
                  </DialogHeader>
                  <div className="space-y-4">
                    <div className="space-y-2">
                      <Label htmlFor="empName">Họ và tên *</Label>
                      <Input placeholder="Nhập họ và tên" />
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="empEmail">Email *</Label>
                        <Input type="email" placeholder="Nhập email" />
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="empPhone">Số điện thoại *</Label>
                        <Input placeholder="Nhập số điện thoại" />
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="username">Tên đăng nhập *</Label>
                        <Input placeholder="Nhập tên đăng nhập" />
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="password">Mật khẩu *</Label>
                        <Input type="password" placeholder="Mật khẩu mặc định: 112233aA" defaultValue="112233aA" />
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <Label htmlFor="position">Chức vụ *</Label>
                        <Select>
                          <SelectTrigger>
                            <SelectValue placeholder="Chọn chức vụ" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="manager">Quản lý hub</SelectItem>
                            <SelectItem value="supervisor">Giám sát</SelectItem>
                            <SelectItem value="staff">Nhân viên</SelectItem>
                            <SelectItem value="driver">Tài xế</SelectItem>
                            <SelectItem value="warehouse">Nhân viên kho</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="department">Phòng ban *</Label>
                        <Select>
                          <SelectTrigger>
                            <SelectValue placeholder="Chọn phòng ban" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="operations">Vận hành</SelectItem>
                            <SelectItem value="warehouse">Kho vận</SelectItem>
                            <SelectItem value="transport">Vận chuyển</SelectItem>
                            <SelectItem value="customer">Chăm sóc KH</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                    </div>
                    <div className="flex justify-end gap-2">
                      <Button variant="outline" onClick={() => setShowCreateEmployeeDialog(false)}>
                        Hủy
                      </Button>
                      <Button onClick={() => {
                        setShowCreateEmployeeDialog(false);
                        toast({
                          title: "Thành công",
                          description: "Tạo tài khoản người dùng nội bộ thành công!",
                        });
                      }}>
                        Tạo tài khoản
                      </Button>
                    </div>
                  </div>
                </DialogContent>
              </Dialog>
              <Dialog open={showAssignEmployeeDialog} onOpenChange={setShowAssignEmployeeDialog}>
                <DialogTrigger asChild>
                  <Button onClick={handleAssignEmployee}>
                    <Users className="h-4 w-4 mr-2" />
                    Gán nhân viên
                  </Button>
                </DialogTrigger>
                <DialogContent className="max-w-2xl">
                  <DialogHeader>
                    <DialogTitle>Gán nhân viên vào bưu cục</DialogTitle>
                  </DialogHeader>
                  <div className="space-y-4">
                    <div className="space-y-2">
                      <Label>Chọn bưu cục</Label>
                      <Select>
                        <SelectTrigger>
                          <SelectValue placeholder="Chọn bưu cục" />
                        </SelectTrigger>
                        <SelectContent>
                          {hubs.map((hub) => (
                            <SelectItem key={hub.id} value={hub.id}>
                              {hub.name} ({hub.code})
                            </SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>
                    <div className="space-y-2">
                      <Label>Danh sách tài khoản có sẵn</Label>
                      <div className="border rounded-lg max-h-64 overflow-y-auto">
                        {availableUsers.map((user) => (
                          <div key={user.id} className="flex items-center justify-between p-3 border-b last:border-b-0">
                            <div className="flex items-center gap-3">
                              <input type="checkbox" className="rounded" />
                              <div>
                                <div className="font-medium">{user.name}</div>
                                <div className="text-sm text-muted-foreground">{user.email}</div>
                                <div className="text-xs text-muted-foreground">
                                  {user.position} - {user.department}
                                </div>
                                {user.assignedHubs.length > 0 && (
                                  <div className="text-xs text-blue-600 mt-1">
                                    Đã gán: {user.assignedHubs.length} bưu cục
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="flex justify-end gap-2">
                      <Button variant="outline" onClick={() => setShowAssignEmployeeDialog(false)}>
                        Hủy
                      </Button>
                      <Button onClick={() => {
                        setShowAssignEmployeeDialog(false);
                        toast({
                          title: "Thành công",
                          description: "Gán nhân viên vào bưu cục thành công!",
                        });
                      }}>
                        Gán nhân viên
                      </Button>
                    </div>
                  </div>
                </DialogContent>
              </Dialog>
            </div>
          </div>

          {/* Employees Table */}
          <Card>
            <CardContent className="p-6">
              <div className="w-full overflow-x-auto">
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead className="min-w-[16em]">
                        <div className="flex items-center gap-2">
                          Nhân viên
                          <ArrowUpDown className="h-4 w-4 cursor-pointer" />
                        </div>
                      </TableHead>
                      <TableHead className="min-w-[16em]">Liên hệ</TableHead>
                      <TableHead className="min-w-[16em]">Hub</TableHead>
                      <TableHead className="min-w-[16em]">Chức vụ</TableHead>
                      <TableHead className="min-w-[16em]">Phòng ban</TableHead>
                      <TableHead className="min-w-[16em]">Ngày vào làm</TableHead>
                      <TableHead className="min-w-[16em]">
                        <div className="flex items-center gap-2">
                          Trạng thái
                          <ArrowUpDown className="h-4 w-4 cursor-pointer" />
                        </div>
                      </TableHead>
                      <TableHead className="w-[200px] text-center sticky right-0 bg-background z-10 border-l">Thao tác</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {employees.map((employee) => (
                      <TableRow key={employee.id}>
                        <TableCell>
                          <div>
                            <div 
                              className="font-medium cursor-pointer flex items-center gap-2"
                              onMouseEnter={() => setHoveredField(`emp-name-${employee.id}`)}
                              onMouseLeave={() => setHoveredField(null)}
                              onClick={() => copyToClipboard(employee.name)}
                            >
                              {employee.name}
                              {hoveredField === `emp-name-${employee.id}` && (
                                <Copy className="h-3 w-3 text-muted-foreground" />
                              )}
                            </div>
                            <div 
                              className="text-sm text-muted-foreground cursor-pointer flex items-center gap-2"
                              onMouseEnter={() => setHoveredField(`emp-id-${employee.id}`)}
                              onMouseLeave={() => setHoveredField(null)}
                              onClick={() => copyToClipboard(employee.id)}
                            >
                              {employee.id}
                              {hoveredField === `emp-id-${employee.id}` && (
                                <Copy className="h-3 w-3 text-muted-foreground" />
                              )}
                            </div>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="space-y-1 text-sm">
                            <div 
                              className="flex items-center gap-1 cursor-pointer"
                              onMouseEnter={() => setHoveredField(`emp-email-${employee.id}`)}
                              onMouseLeave={() => setHoveredField(null)}
                              onClick={() => copyToClipboard(employee.email)}
                            >
                              <Mail className="h-3 w-3" />
                              <span>{employee.email}</span>
                              {hoveredField === `emp-email-${employee.id}` && (
                                <Copy className="h-3 w-3 text-muted-foreground ml-1" />
                              )}
                            </div>
                            <div 
                              className="flex items-center gap-1 cursor-pointer"
                              onMouseEnter={() => setHoveredField(`emp-phone-${employee.id}`)}
                              onMouseLeave={() => setHoveredField(null)}
                              onClick={() => copyToClipboard(employee.phone)}
                            >
                              <Phone className="h-3 w-3" />
                              <span>{employee.phone}</span>
                              {hoveredField === `emp-phone-${employee.id}` && (
                                <Copy className="h-3 w-3 text-muted-foreground ml-1" />
                              )}
                            </div>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="flex items-center gap-1">
                            <Building2 className="h-3 w-3" />
                            <span className="text-sm">{employee.hubName}</span>
                          </div>
                        </TableCell>
                        <TableCell>
                          <Badge variant="outline">{employee.position}</Badge>
                        </TableCell>
                        <TableCell>
                          <div className="text-sm">{employee.department}</div>
                        </TableCell>
                        <TableCell>
                          <div className="flex items-center gap-1 text-sm">
                            <Calendar className="h-3 w-3" />
                            <span>{new Date(employee.joinDate).toLocaleDateString('vi-VN')}</span>
                          </div>
                        </TableCell>
                        <TableCell>
                          <Badge className={getStatusColor(employee.status)}>
                            {employee.status === 'active' ? 'Hoạt động' : 'Ngừng làm'}
                          </Badge>
                        </TableCell>
                        <TableCell className="sticky right-0 bg-background z-10 border-l">
                          <div className="flex items-center gap-1 justify-center">
                            <Button 
                              size="sm" 
                              variant="ghost"
                              onClick={() => handleEditEmployee(employee)}
                              title="Chỉnh sửa"
                            >
                              <Edit className="h-4 w-4" />
                            </Button>
                            <Button 
                              size="sm" 
                              variant="ghost"
                              onClick={() => handleDeleteEmployee(employee)}
                              title="Xóa"
                            >
                              <Trash2 className="h-4 w-4" />
                            </Button>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="analytics" className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {/* Hub Performance Cards */}
            {hubs.map((hub) => {
              const loadPercentage = getLoadPercentage(hub.currentLoad, hub.capacity);
              return (
                <Card key={hub.id}>
                  <CardHeader className="pb-3">
                    <CardTitle className="text-base flex items-center gap-2">
                      <Building className="h-4 w-4" />
                      {hub.name}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-3">
                    <div className="flex justify-between text-sm">
                      <span>Công suất:</span>
                      <span className={getLoadColor(loadPercentage)}>
                        {loadPercentage}%
                      </span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div 
                        className={`h-2 rounded-full ${
                          loadPercentage >= 90 ? 'bg-red-500' : 
                          loadPercentage >= 70 ? 'bg-yellow-500' : 'bg-green-500'
                        }`}
                        style={{ width: `${Math.min(loadPercentage, 100)}%` }}
                      ></div>
                    </div>
                    <div className="grid grid-cols-2 gap-2 text-sm">
                      <div>
                        <div className="text-muted-foreground">Nhân viên</div>
                        <div className="font-medium">{hub.employeeCount}</div>
                      </div>
                      <div>
                        <div className="text-muted-foreground">Trạng thái</div>
                        <div>
                                                     <Badge className={getStatusColor(hub.status)}>
                             {getStatusText(hub.status)}
                           </Badge>
                        </div>
                      </div>
                    </div>
                    <div className="pt-2">
                      <div className="text-xs text-muted-foreground">Dịch vụ:</div>
                      <div className="flex flex-wrap gap-1 mt-1">
                        {hub.services.slice(0, 2).map((service, index) => (
                          <Badge key={index} variant="outline" className="text-xs">
                            {service}
                          </Badge>
                        ))}
                        {hub.services.length > 2 && (
                          <Badge variant="outline" className="text-xs">
                            +{hub.services.length - 2}
                          </Badge>
                        )}
                      </div>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </TabsContent>
      </Tabs>

      {/* Hub Details Dialog */}
      <Dialog open={showHubDetailsDialog} onOpenChange={setShowHubDetailsDialog}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>Chi tiết bưu cục - {selectedHub?.name}</DialogTitle>
          </DialogHeader>
          {selectedHub && (
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label className="font-medium">Mã bưu cục</Label>
                  <p className="text-sm">{selectedHub.code}</p>
                </div>
                <div className="space-y-2">
                  <Label className="font-medium">Loại</Label>
                  <Badge className={getTypeColor(selectedHub.type)}>
                    {selectedHub.type}
                  </Badge>
                </div>
                <div className="space-y-2">
                  <Label className="font-medium">Địa chỉ</Label>
                  <p className="text-sm">{selectedHub.address}</p>
                </div>
                <div className="space-y-2">
                  <Label className="font-medium">Quản lý</Label>
                  <p className="text-sm">{selectedHub.manager}</p>
                </div>
                <div className="space-y-2">
                  <Label className="font-medium">Email</Label>
                  <p className="text-sm">{selectedHub.email}</p>
                </div>
                <div className="space-y-2">
                  <Label className="font-medium">Số điện thoại</Label>
                  <p className="text-sm">{selectedHub.phone}</p>
                </div>
                <div className="space-y-2">
                  <Label className="font-medium">Giờ hoạt động</Label>
                  <p className="text-sm">{selectedHub.operatingHours}</p>
                </div>
                <div className="space-y-2">
                  <Label className="font-medium">Trạng thái</Label>
                  <Badge className={getStatusColor(selectedHub.status)}>
                    {getStatusText(selectedHub.status)}
                  </Badge>
                </div>
                <div className="space-y-2">
                  <Label className="font-medium">Công suất</Label>
                  <p className="text-sm">
                    {selectedHub.currentLoad.toLocaleString()} / {selectedHub.capacity.toLocaleString()} 
                    ({getLoadPercentage(selectedHub.currentLoad, selectedHub.capacity)}%)
                  </p>
                </div>
                <div className="space-y-2">
                  <Label className="font-medium">Nhân sự</Label>
                  <p className="text-sm">{selectedHub.employeeCount} nhân viên</p>
                </div>
              </div>
              <div className="space-y-2">
                <Label className="font-medium">Dịch vụ</Label>
                <div className="flex flex-wrap gap-2">
                  {selectedHub.services.map((service, index) => (
                    <Badge key={index} variant="outline">{service}</Badge>
                  ))}
                </div>
              </div>
              <div className="flex justify-end">
                <Button variant="outline" onClick={() => setShowHubDetailsDialog(false)}>
                  Đóng
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Edit Hub Dialog */}
      <Dialog open={showEditHubDialog} onOpenChange={setShowEditHubDialog}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>Chỉnh sửa bưu cục - {selectedHub?.name}</DialogTitle>
          </DialogHeader>
          {selectedHub && (
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="editHubName">Tên hub *</Label>
                  <Input defaultValue={selectedHub.name} placeholder="Nhập tên hub" />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="editHubCode">Mã hub *</Label>
                  <Input defaultValue={selectedHub.code} placeholder="Nhập mã hub" />
                </div>
              </div>
              <div className="space-y-2">
                <Label htmlFor="editHubType">Loại hub *</Label>
                <Select defaultValue={selectedHub.type}>
                  <SelectTrigger>
                    <SelectValue placeholder="Chọn loại hub" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="Trung tâm khai thác">Trung tâm khai thác</SelectItem>
                    <SelectItem value="Chi nhánh">Chi nhánh</SelectItem>
                    <SelectItem value="Bến xe">Bến xe</SelectItem>
                    <SelectItem value="Kho hàng">Kho hàng</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div className="space-y-2">
                <Label htmlFor="editAddress">Địa chỉ *</Label>
                <Input defaultValue={selectedHub.address} placeholder="Nhập địa chỉ đầy đủ" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="editPhone">Số điện thoại *</Label>
                  <Input defaultValue={selectedHub.phone} placeholder="Nhập số điện thoại" />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="editEmail">Email *</Label>
                  <Input type="email" defaultValue={selectedHub.email} placeholder="Nhập email" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="editManager">Quản lý *</Label>
                  <Input defaultValue={selectedHub.manager} placeholder="Tên quản lý" />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="editCapacity">Sức chứa *</Label>
                  <Input type="number" defaultValue={selectedHub.capacity} placeholder="Sức chứa tối đa" />
                </div>
              </div>
              <div className="space-y-2">
                <Label htmlFor="editOperatingHours">Giờ hoạt động *</Label>
                <Input defaultValue={selectedHub.operatingHours} placeholder="VD: 06:00 - 22:00" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="editStatus">Trạng thái *</Label>
                <Select defaultValue={selectedHub.status}>
                  <SelectTrigger>
                    <SelectValue placeholder="Chọn trạng thái" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="active">Hoạt động</SelectItem>
                    <SelectItem value="maintenance">Bảo trì</SelectItem>
                    <SelectItem value="inactive">Ngừng hoạt động</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div className="flex justify-end gap-2">
                <Button variant="outline" onClick={() => setShowEditHubDialog(false)}>
                  Hủy
                </Button>
                <Button onClick={() => {
                  setShowEditHubDialog(false);
                  toast({
                    title: "Thành công",
                    description: "Cập nhật thông tin bưu cục thành công!",
                  });
                }}>
                  Cập nhật
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Edit Employee Dialog */}
      <Dialog open={showEditEmployeeDialog} onOpenChange={setShowEditEmployeeDialog}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Chỉnh sửa nhân viên - {selectedEmployee?.name}</DialogTitle>
          </DialogHeader>
          {selectedEmployee && (
            <div className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="editEmpName">Họ và tên *</Label>
                <Input defaultValue={selectedEmployee.name} placeholder="Nhập họ và tên" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="editEmpEmail">Email *</Label>
                  <Input type="email" defaultValue={selectedEmployee.email} placeholder="Nhập email" />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="editEmpPhone">Số điện thoại *</Label>
                  <Input defaultValue={selectedEmployee.phone} placeholder="Nhập số điện thoại" />
                </div>
              </div>
              <div className="space-y-2">
                <Label htmlFor="editHubAssign">Hub được phân công *</Label>
                <Select defaultValue={selectedEmployee.hubId}>
                  <SelectTrigger>
                    <SelectValue placeholder="Chọn hub" />
                  </SelectTrigger>
                  <SelectContent>
                    {hubs.map((hub) => (
                      <SelectItem key={hub.id} value={hub.id}>
                        {hub.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="editPosition">Chức vụ *</Label>
                  <Select defaultValue={selectedEmployee.position}>
                    <SelectTrigger>
                      <SelectValue placeholder="Chọn chức vụ" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="Quản lý hub">Quản lý hub</SelectItem>
                      <SelectItem value="Giám sát">Giám sát</SelectItem>
                      <SelectItem value="Nhân viên kho">Nhân viên kho</SelectItem>
                      <SelectItem value="Tài xế">Tài xế</SelectItem>
                      <SelectItem value="Nhân viên">Nhân viên</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div className="space-y-2">
                  <Label htmlFor="editDepartment">Phòng ban *</Label>
                  <Select defaultValue={selectedEmployee.department}>
                    <SelectTrigger>
                      <SelectValue placeholder="Chọn phòng ban" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="Vận hành">Vận hành</SelectItem>
                      <SelectItem value="Kho vận">Kho vận</SelectItem>
                      <SelectItem value="Vận chuyển">Vận chuyển</SelectItem>
                      <SelectItem value="Chăm sóc KH">Chăm sóc KH</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              </div>
              <div className="flex justify-end gap-2">
                <Button variant="outline" onClick={() => setShowEditEmployeeDialog(false)}>
                  Hủy
                </Button>
                <Button onClick={() => {
                  setShowEditEmployeeDialog(false);
                  toast({
                    title: "Thành công",
                    description: "Cập nhật thông tin nhân viên thành công!",
                  });
                }}>
                  Cập nhật
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Hubs;
